import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const BookingstatushistoryAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		bookingid: yup.string().required().label("Bookingid"),
		oldstatus: yup.string().nullable().label("Oldstatus"),
		newstatus: yup.string().required().label("Newstatus"),
		changedby: yup.string().nullable().label("Changedby"),
		changedbytype: yup.string().nullable().label("Changedbytype"),
		changereason: yup.string().nullable().label("Changereason"),
		changedat: yup.string().nullable().label("Changedat"),
		notes: yup.string().nullable().label("Notes")
	});
	
	//form default values
	const formDefaultValues = {
		bookingid: '', 
		oldstatus: '', 
		newstatus: '', 
		changedby: '', 
		changedbytype: '', 
		changereason: '', 
		changedat: "(getdate())", 
		notes: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/bookingstatushistory`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="BookingstatushistoryAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Bookingstatushistory"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Bookingid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/bookingid_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="bookingid"     optionLabel="label" optionValue="value" value={formik.values.bookingid} onChange={formik.handleChange} options={response} label="Bookingid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.bookingid)}   />
                                                    <ErrorMessage name="bookingid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Oldstatus 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="oldstatus"  onChange={formik.handleChange}  value={formik.values.oldstatus}   label="Oldstatus" type="text" placeholder="Enter Oldstatus"        className={inputClassName(formik?.errors?.oldstatus)} />
                                                <ErrorMessage name="oldstatus" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Newstatus *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="newstatus"  onChange={formik.handleChange}  value={formik.values.newstatus}   label="Newstatus" type="text" placeholder="Enter Newstatus"        className={inputClassName(formik?.errors?.newstatus)} />
                                                <ErrorMessage name="newstatus" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Changedby 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="changedby"     optionLabel="label" optionValue="value" value={formik.values.changedby} onChange={formik.handleChange} options={response} label="Changedby"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.changedby)}   />
                                                    <ErrorMessage name="changedby" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Changedbytype 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="changedbytype"  onChange={formik.handleChange}  value={formik.values.changedbytype}   label="Changedbytype" type="text" placeholder="Enter Changedbytype"        className={inputClassName(formik?.errors?.changedbytype)} />
                                                <ErrorMessage name="changedbytype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Changereason 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="changereason"  onChange={formik.handleChange}  value={formik.values.changereason}   label="Changereason" type="text" placeholder="Enter Changereason"        className={inputClassName(formik?.errors?.changereason)} />
                                                <ErrorMessage name="changereason" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Changedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="changedat" value={formik.values.changedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.changedat)}        />
                                                <ErrorMessage name="changedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Notes 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="notes"  onChange={formik.handleChange}  value={formik.values.notes}   label="Notes" type="text" placeholder="Enter Notes"        className={inputClassName(formik?.errors?.notes)} />
                                                <ErrorMessage name="notes" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
BookingstatushistoryAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'bookingstatushistory',
	apiPath: 'bookingstatushistory/add',
	routeName: 'bookingstatushistoryadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default BookingstatushistoryAddPage;
